/**
 * Ellipsizes a string to show only the first and last few characters.
 */
export function ellipsizeString(str?: string | null, visibleChars?: number) {
  if (str == null) return '';
  if (
    visibleChars == null ||
    visibleChars == -1 ||
    str.length <= visibleChars * 2 + 2
  )
    return str;
  return `${str.slice(0, visibleChars)}…${str.slice(-visibleChars)}`;
}
